var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"head"}},[_c('h1',[_vm._v("Pin "+_vm._s(_vm.name.slice(-3)))]),_c('p',[_c('img',{attrs:{"src":require("@/assets/images/macnum.png"),"alt":""}}),_vm._v(" "+_vm._s(_vm.pinNumber)+" "),_c('img',{staticClass:"battery",attrs:{"src":_vm.image,"height":"14"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }